import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'jumpSeatDisplay',
    standalone: false
})
export class JumpSeatDisplayPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value === 'ON') {
      return '1';
    }

    if (value === 'OFF' || value === 'NA') {
      return '0';
    }
    return value;
  }
}
